import React, { Component } from "react";
import authService from "../../services/authService";
import CovidPotvrzeni from "../Covid/CovidPotvrzeni";
import NovinkyPrehled from "../Novinky/NovinkyPrehled";

class HomePage extends Component {
  state = {};

  componentDidMount = () => {
    /*const user = authService.getCurrentUser();
    if (user.erecept === "1") {
      window.location = "#/e-recept";
    } else if (user.casovani === "1") {
      window.location = "#/casovani";
    } else if (user.housekeeping === "1") {
      window.location = "#/housekeeping";
    } else {
      window.location = "#/covid";
    }*/
  };

  render() {
    return (
      <React.Fragment>
        <NovinkyPrehled />
        <CovidPotvrzeni />
      </React.Fragment>
    );
  }
}

export default HomePage;
